import Axios from 'axios';
import { PATH } from 'envs';
import { useEffect, useState } from 'react';
import { placesElastic } from 'constants/api';
import RESTDataCache from 'dataProvider/api/cacheData';
import { PROPERTIES_JSON } from 'core/constants';
import { getPathFromPlaceAndType } from 'utils/paths';

window.placesFromElastic = {};

/**
 * Hook que nos devuelve informacion del lugar(svg, punto de la capital provincia...)
 * @param {string} ineId
 * @returns
 */

const useGetPlace = (ineId, type) => {
  const [place, setPlace] = useState('');
  useEffect(() => {
    if (!ineId) {
      return;
    }
    if (window.placesFromElastic[`${ineId}_${type}`]) {
      setPlace(window.placesFromElastic[`${ineId}_${type}`]);
      return;
    }
    Axios.get(`${PATH}${placesElastic}${ineId}`)
      .then(response => response.data)
      .then(async response => {
        const props = await RESTDataCache(
          PROPERTIES_JSON(),
          'GLOBAL_CONFIG',
          null
        );
        const placeWithPath = {
          ...response,
          path: getPathFromPlaceAndType(response, type, props)
        };
        window.placesFromElastic[`${ineId}_${type}`] = placeWithPath;

        setPlace(placeWithPath);
      });
  }, [ineId]);

  return place;
};
export default useGetPlace;
